import { useEffect } from "react";

const ChatwootWidget = () => {
  useEffect(() => {
    (function (d, t) {
      const BASE_URL = "https://chat.madritech.co/";
      const g = d.createElement(t);
      const s = d.getElementsByTagName(t)[0];
      g.src = `${BASE_URL}/packs/js/sdk.js`;
      g.defer = true;
      g.async = true;
      s.parentNode.insertBefore(g, s);
      g.onload = function () {
        window.chatwootSDK.run({
          websiteToken: "KnhQZUVbbMtGqqPZ1GpU8J86",
          baseUrl: BASE_URL,
        });
      };
    })(document, "script");
  }, []);

  return null;
};

export default ChatwootWidget;
